import useAppSelector from '@/hooks/useAppSelector'
import { selectServiceAreas } from '@/redux/slices/commonData'

export function useServiceAreas() {
  return useAppSelector(selectServiceAreas())
}
